import { delayBy } from "@/fp";
import { to_query_params } from "@/utils/url";
import {
  EventsFilter,
  ItemFilter,
  Pagination,
  PaginationAndLabels,
} from "@/gql/types";

import axios from "axios";

export interface GqlResolverPayload<T> {
  type: GqlCallsKey;
  payload: T;
}

export type GqlCallsKey =
  | "ms-365-gen-ai.risk-cells"
  | "ms-365-gen-ai.ai-label-rows"
  | "ms-365-gen-ai.interaction-cells"
  | "ms-365-gen-ai.interaction-employees"
  | "ms-365-gen-ai.ai-content-items"
  | "ms-365-gen-ai.event-by-id"
  | "ms-365-gen-ai.events-by-category"
  | "investigation.summary.infoTypes"
  | "investigation.summary.insights"
  | "l1"
  | "anonymous-user-id"
  | "detection.get"
  | "items.get"
  | "item.get"
  | "folders.get"
  | "contacts.get"
  | "personal-address.get"
  | "employees.get"
  | "assets"
  | "risky-event.per_info_type"
  | "files-for-contact.get"
  | "files-for-employee.get"
  | "files-for-folder.get"
  | "events-for-contact.get"
  | "events-for-employee.get"
  | "mapping-files.get"
  | "mapping-events.get"
  | "mapping-folders.get"
  | "mapping-contacts.get"
  | "mapping-organizations.get"
  | "mapping-employees.get"
  | "mapping-sources.get"
  | "total-risk-count-for-label"
  | "mapping-drilldown.get"
  | "maaping-drilldown.sidebar.get"
  | "detection-drilldown.get"
  | "row-events"
  | "row-files"
  | "events.get"
  | "time-line.get"
  | "event.items.get"
  | "event.entities.get"
  | "entities.search"
  | "files.search"
  | "report-time"
  | "event.get"
  | "mapping-tier1.all_pii_labels_count"
  | "mapping-tier1.files"
  | "mapping-tier1.folders"
  | "mapping-tier1.employees"
  | "mapping-tier1.employees-sender"
  | "mapping-tier1.employees-receiver"
  | "mapping-tier1.private-emails"
  | "mapping-tier1.contacts"
  | "mapping-tier1.organizations"
  | "mapping-tier1.sources"
  | "detection-tier2.get"
  | "insights.get"
  | "insights-counters.get"
  | "insights-driildown.get"
  | "tier2-contacts"
  | "tier2-employees"
  | "tier2-folders"
  | "tier2-organizations"
  | "tier2-personal"
  | "tier3-events"
  | "tier3-items"
  | "mapping-tier1.external_share_anomaly"
  | "mapping-tier1.via_unsecured_link"
  | "mapping-tier1.shared_to_personal_address"
  | "mapping-tier1.shared_inside_organization_anomalously"
  | "mapping-tier1.via_unsecured_link"
  | "mapping-tier1.external_share"
  | "mapping-tier1.critical_external_share_anomaly"
  | "mapping-tier1.critical_via_unsecured_link"
  | "mapping-tier1.critical_shared_to_personal_address"
  | "mapping-tier1.critical_shared_inside_organization_anomalously"
  | "mapping-tier1.critical_via_unsecured_link"
  | "mapping-tier1.critical_external_share"
  | "mip-cognni-labels-ready-state"
  | "over-exposure"
  | "critical-over-exposure"
  | "over-sharing"
  | "critical-over-sharing"
  | "unsecure-sharing"
  | "critical-unsecure-sharing"
  | "lack-of-mip-labeling"
  | "critical-lack-of-mip-labeling"
  | "risks-scores"
  | "risk-score-for-insight"
  | "what-is-the-information"
  | "where-is-the-information"
  | "who-was-exposed"
  | "what-is-exposure"
  | "how-it-was-shared"
  | "over-exposure-l1"
  | "unsecure-sharing-l1"
  | "over-sharing-l1"
  | "info-at-rest-providers.sensitive-folders"
  | "info-at-rest-providers.sensitive-files"
  | "info-at-rest-label-counter-per-container"
  | "info-at-rest-containers"
  | "info-at-rest-search-folders"
  | "info-at-rest-search-files"
  | "info-at-rest-container-overview"
  | "info-at-rest-folder-drilldown-folders"
  | "info-at-rest-folder-drilldown-files"
  | "info-at-rest-l1s"
  | "info-at-rest-l1-files-drilldown"
  | "info-at-rest-l1-folders-drilldown"
  | "info-at-rest-folder"
  | "entity-by-id"
  | "compliance-insights-sources"
  | "compliance-insights-entity"
  | "risk-score-for-threat"
  | "top10-exposures"
  | "l1-exposures"
  | "l2-exposures"
  | "l1-exposure-entities"
  | "overview.so-far.compliance-events-count"
  | "overview-compliance.risky-users-per-insight"
  | "exposure-events"
  | "compliance.insights-events-count"
  | "entities.get"
  | "executives.high-risk-events-per-l1"
  | "compliance.events-profile-count-for-label"
  | "compliance.events-count-per-l1"
  | "compliance.employees-per-events-profile-count-for-label"
  | "compliance.employees-count-per-l1"
  | "mapping-tier1.personal"
  | "detection-regulated"
  | "get_files"
  | "what.ms-labels-coverage"
  | "where.from-cloud-folders"
  | "where.from-employees"
  | "where.to-employees"
  | "where.to-external"
  | "where.to-organizations"
  | "departments-info.from-cloud-folders"
  | "departments-info.from-employees"
  | "departments-info.to-employees"
  | "departments-info.to-external"
  | "departments-info.to-organizations"
  | "departments-info.as-events"
  | "folders-info.from-cloud-folders"
  | "folders-info.from-employees"
  | "folders-info.to-employees"
  | "folders-info.to-external"
  | "folders-info.to-organizations"
  | "folders-info.as-events"
  | "how.untrusted-employees"
  | "how.untrusted-orgs"
  | "how.untrusted-personal-address"
  | "how.untrusted-link"
  | "risky-users.count-approximation"
  | "evidences.employees"
  | "evidences.orgs"
  | "evidences.personal"
  | "evidences.anonymous-link"
  | "evidences.new-internal-exposure"
  | "evidences.new-external-exposure"
  | "evidences.downloaded-anomaly"
  | "unprotected-accounts.user-stats"
  | "security-posture.dlp-files-sharepoint"
  | "info-at-rest-files-for-application-for-label"
  | "get_files_per_label_per_application"
  | "security-posture.governance-files-count"
  | "security-posture.data-protection-files-count"
  | "security-posture.information-compliance-high-severity-incidents-count"
  | "inv-counters.employee-receivers"
  | "inv-counters.employee-senders"
  | "inv-counters.employees"
  | "inv-counters.organizations"
  | "inv-counters.external-contacts"
  | "inv-counters.private-emails"
  | "inv-counters.folders"
  | "inv-counters.files"
  | "inv-counters.events"
  // ms-365-activities
  | "ms-365-activities.events-count-for-l0"
  | "ms-365-activities.risk-events-for-l0"
  | "ms-365-activities.data-in-apps"
  | "ms-365-activities.information-shared"
  | "ms-365-activities.mip-labeling"
  | "ms-365-activities.information-shared-employee-receiver"
  | "ms-365-activities.information-shared-employee-sender"
  | "ms-365-activities.information-shared-org-receiver"
  | "ms-365-activities.information-shared-personal-receiver"
  | "ms-365-activities.high-risk-events-findings";

export type GqlCallResolverFn = (payload?: any) => Promise<{ data: any }>;

//#region  insights
const getInsights: GqlCallResolverFn = async () => await axios.get(`/insights`);

const getInsightsDrildown: GqlCallResolverFn = async (filter: any) => {
  const { id, pagination } = filter;
  const params = to_query_params(pagination);
  return await axios.get(`/insights/items/${id}?${params}`);
};

//#endregion

//#region detection driildown tier1
const getDetectionDrilldownTier1: GqlCallResolverFn = async (label: string) => {
  return await axios.get(`/detection-tier2/${label}`);
};
//#endregion

//#region  search
const searchFiles: GqlCallResolverFn = async (filter: any) => {
  const { limit, offset } = filter.pagination || { offset: 0, limit: 100 };
  return await axios.get(
    `/entities/search/type/files/query/${filter.searchCriteria}?offset=${offset}&limit=${limit}`
  );
};

const searchEntities: GqlCallResolverFn = async (filter: any) => {
  let type = "contacts";
  const { isExternal, objectType } = filter;
  switch (true) {
    case isExternal && objectType === "people":
      type = "contacts";
      break;
    case isExternal && objectType === "people-private":
      type = "personal-address";
      break;
    case !isExternal && objectType === "people":
      type = "employees";
      break;
    default:
      type = "folders";
      break;
  }
  const { limit, offset } = filter.pagination || { offset: 0, limit: 100 };
  return await axios.get(
    `/entities/search/type/${type}/query/${filter.searchCriteria}?offset=${offset}&limit=${limit}`
  );
};
//#endregion

const totalRiskCountForLabel: GqlCallResolverFn = async (labelId: string) =>
  await axios.get(`/counts/total-risk-count/${labelId}`);

//#region  LABELS
const getL1Labels: GqlCallResolverFn = async () =>
  await axios.get("/labels/L1");

//#endregion

//#region  ENTITIES
//#region contacts
const getContacts: GqlCallResolverFn = async (pagination: Pagination) => {
  const { offset = 0, limit = 50 } = pagination;
  return await axios.get(
    `/entities/contacts/*?offset=${offset}&limit=${limit}`
  );
};
//#endregion

//#region  personal-address
const getPersonalAddress: GqlCallResolverFn = async (
  pagination: Pagination
) => {
  const { offset = 0, limit = 50 } = pagination;
  return await axios.get(
    `/entities/personal-address/*?offset=${offset}&limit=${limit}`
  );
};
//#endregion

//#region employees
const getEmployees: GqlCallResolverFn = async (pagination: Pagination) => {
  const { offset = 0, limit = 50 } = pagination;
  return await axios.get(
    `/entities/employees/*?offset=${offset}&limit=${limit}`
  );
};
//#endregion

//#region files
const getFiles: GqlCallResolverFn = async (pagination: Pagination) => {
  const { offset = 0, limit = 50 } = pagination;
  return await axios.get(`/entities/files/*?offset=${offset}&limit=${limit}`);
};
//#endregion

//#region folders
const getFolders: GqlCallResolverFn = async (pagination: Pagination) => {
  const { offset = 0, limit = 50 } = pagination;
  return await axios.get(`/entities/folders/*?offset=${offset}&limit=${limit}`);
};
//#endregion
//#endregion entities

//#region ASSETS
const getAssets: GqlCallResolverFn = async () =>
  await axios.get("/counts/assets");

const getReportTime: GqlCallResolverFn = async () =>
  await axios.get("/counts/report-time");

//#endregion

//#region MAPPING
const getMappingFiles: GqlCallResolverFn = async () =>
  await axios.get("/counts/mapping-files");

const getMappingFolders: GqlCallResolverFn = async () =>
  await axios.get("/counts/mapping-folders");

const getMappingContacts: GqlCallResolverFn = async () =>
  await axios.get("/counts/mapping-contacts");

const getMappingOrganizations: GqlCallResolverFn = async () =>
  await axios.get("/counts/mapping-organizations");

const getMappingEmployees: GqlCallResolverFn = async () =>
  await axios.get("/counts/mapping-employees");

const getMappingSources: GqlCallResolverFn = async () =>
  await axios.get("/counts/mapping-sources");
//#endregion

//#region mapping drill down side bar

const getFilesForContact: GqlCallResolverFn = async (p: {
  id: string;
  start: number;
  infoTypeIds: string[];
}) =>
  await axios.get(
    `/entities/files-for-contact/${encodeURIComponent(p.id)}/label/${
      p.infoTypeIds[0]
    }`
  );

const getFilesForEmployee: GqlCallResolverFn = async (p: {
  id: string;
  start: number;
  infoTypeIds: string[];
}) =>
  await axios.get(
    `/entities/files-for-employee/${encodeURIComponent(
      p.id
    )}/label/${encodeURIComponent(p.infoTypeIds[0])}`
  );

const getFilesForFolder: GqlCallResolverFn = async (p: {
  id: string;
  start: number;
  infoTypeIds: string[];
}) =>
  await axios.get(
    `/entities/files-for-folder/${encodeURIComponent(
      p.id
    )}/label/${encodeURIComponent(p.infoTypeIds[0])}`
  );

//#endregion

//#region  events for mapping side bar
const getEventsForContact: GqlCallResolverFn = async (p: {
  id: string;
  start: number;
  infoTypeIds: string[];
}) => {
  return await axios.get(
    `/events/events-for-contact/${encodeURIComponent(p.id)}/label/${
      p.infoTypeIds[0]
    }`
  );
};

const getEventsForEmployee: GqlCallResolverFn = async (p: {
  id: string;
  start: number;
  infoTypeIds: string[];
}) =>
  await axios.get(
    `/events/events-for-employee/${encodeURIComponent(
      p.id
    )}/label/${encodeURIComponent(p.infoTypeIds[0])}`
  );
//#endregion

//#region detection
const getDetectionDashboard: GqlCallResolverFn = async () =>
  await axios.get(`/counts/detection`);
//#endregion

//#region EVENTS
const getEvents: GqlCallResolverFn = async (filter: EventsFilter) => {
  const res = await axios.post(`/events`, filter);
  return res;
};

const getEventsForTimeLine: GqlCallResolverFn = async (
  filter: EventsFilter
) => {
  const res = await axios.post(`/events/time-line`, filter);
  return res;
};
//#endregion

//#region  event by id
const getEventById: GqlCallResolverFn = async (id: string) => {
  await delayBy(2000);
  return await axios.get(`/events/event/${id}`);
};

//#endregion

//#region  mapping tier1
const getFilesForMappingTier1: GqlCallResolverFn = async (labelId: string) => {
  return await axios.get(`/mapping-tier1/files/${labelId}`);
};

const getFoldersForMappingTier1: GqlCallResolverFn = async (
  p: PaginationAndLabels
) => {
  const {
    contentLabels = [],
    pagination: { offset = 0, limit = 50 },
  } = p;

  // @ts-ignore
  return await axios.get(
    // @ts-ignore
    `/mapping-tier1/folders/${contentLabels[0]}?offset=${offset}&limit=${limit}`
  );
};

const getEmployeesForMappingTier1: GqlCallResolverFn = async (
  p: PaginationAndLabels
) => {
  const {
    contentLabels = [],
    pagination: { offset = 0, limit = 50 },
  } = p;
  // @ts-ignore
  return await axios.get(
    // @ts-ignore
    `/mapping-tier1/employees/${contentLabels[0]}?offset=${offset}&limit=${limit}`
  );
};

const getContactsForMappingTier1: GqlCallResolverFn = async (
  p: PaginationAndLabels
) => {
  const {
    contentLabels = [],
    pagination: { offset = 0, limit = 50 },
  } = p;
  // @ts-ignore
  return await axios.get(
    // @ts-ignore
    `/mapping-tier1/contacts/${contentLabels[0]}?offset=${offset}&limit=${limit}`
  );
};

const getOrganizationsForMappingTier1: GqlCallResolverFn = async (
  p: PaginationAndLabels
) => {
  const {
    contentLabels = [],
    pagination: { offset = 0, limit = 50 },
  } = p;
  // @ts-ignore
  return await axios.get(
    // @ts-ignore
    `/mapping-tier1/organizations/${contentLabels[0]}?offset=${offset}&limit=${limit}`
  );
};

const getSourcesForMappingTier1: GqlCallResolverFn = async (source: string) => {
  return await axios.get(
    // @ts-ignore
    `/mapping-tier1/sources/${source}`
  );
};
//#endregion

//#region new investigation
const getTier3Items: GqlCallResolverFn = async (filter: ItemFilter) => {
  return await axios.post(
    // @ts-ignore
    `/investigation/files`,
    filter
  );
};

const getTier3Events: GqlCallResolverFn = async (filter: EventsFilter) => {
  return await axios.post(
    // @ts-ignore
    `/investigation/events`,
    filter
  );
};

const getTier2Contacts: GqlCallResolverFn = async (filter: EventsFilter) => {
  return await axios.post(
    // @ts-ignore
    `/investigation/contacts`,
    filter
  );
};

const getTier2Employees: GqlCallResolverFn = async (filter: EventsFilter) => {
  return await axios.post(
    // @ts-ignore
    `/investigation/employees`,
    filter
  );
};

const getTier2PersonalContacts: GqlCallResolverFn = async (
  filter: EventsFilter
) => {
  return await axios.post(
    // @ts-ignore
    `/investigation/personal-contacts`,
    filter
  );
};

const getTier2Organizations: GqlCallResolverFn = async (
  filter: EventsFilter
) => {
  return await axios.post(
    // @ts-ignore
    `/investigation/organizations`,
    filter
  );
};

const getTier2Folders: GqlCallResolverFn = async (filter: EventsFilter) => {
  return await axios.post(
    // @ts-ignore
    `/investigation/folders`,
    filter
  );
};
//#endregion

const gqlResolvers: Map<GqlCallsKey, GqlCallResolverFn> = new Map();

// gql resolvers

gqlResolvers.set("total-risk-count-for-label", totalRiskCountForLabel);
gqlResolvers.set("l1", getL1Labels);

gqlResolvers.set("contacts.get", getContacts);
gqlResolvers.set("personal-address.get", getPersonalAddress);
gqlResolvers.set("folders.get", getFolders);
gqlResolvers.set("employees.get", getEmployees);
gqlResolvers.set("items.get", getFiles);

gqlResolvers.set("assets", getAssets);
gqlResolvers.set("report-time", getReportTime);

gqlResolvers.set("mapping-files.get", getMappingFiles);
gqlResolvers.set("mapping-folders.get", getMappingFolders);
gqlResolvers.set("mapping-contacts.get", getMappingContacts);
gqlResolvers.set("mapping-organizations.get", getMappingOrganizations);
gqlResolvers.set("mapping-employees.get", getMappingEmployees);
gqlResolvers.set("mapping-sources.get", getMappingSources);

gqlResolvers.set("files-for-contact.get", getFilesForContact);
gqlResolvers.set("files-for-employee.get", getFilesForEmployee);
gqlResolvers.set("files-for-folder.get", getFilesForFolder);

gqlResolvers.set("events-for-contact.get", getEventsForContact);
gqlResolvers.set("events-for-employee.get", getEventsForEmployee);

gqlResolvers.set("detection.get", getDetectionDashboard);

gqlResolvers.set("events.get", getEvents);
gqlResolvers.set("time-line.get", getEventsForTimeLine);

gqlResolvers.set("event.get", getEventById);

gqlResolvers.set("entities.search", searchEntities);
gqlResolvers.set("files.search", searchFiles);

gqlResolvers.set("mapping-tier1.files", getFilesForMappingTier1);
gqlResolvers.set("mapping-tier1.folders", getFoldersForMappingTier1);
gqlResolvers.set("mapping-tier1.employees", getEmployeesForMappingTier1);
gqlResolvers.set("mapping-tier1.contacts", getContactsForMappingTier1);
gqlResolvers.set(
  "mapping-tier1.organizations",
  getOrganizationsForMappingTier1
);
gqlResolvers.set("mapping-tier1.sources", getSourcesForMappingTier1);

gqlResolvers.set("detection-tier2.get", getDetectionDrilldownTier1);

gqlResolvers.set("insights.get", getInsights);
gqlResolvers.set("insights-driildown.get", getInsightsDrildown);

gqlResolvers.set("tier2-employees", getTier2Employees);
gqlResolvers.set("tier2-contacts", getTier2Contacts);
gqlResolvers.set("tier2-personal", getTier2PersonalContacts);
gqlResolvers.set("tier2-organizations", getTier2Organizations);
gqlResolvers.set("tier2-folders", getTier2Folders);
gqlResolvers.set("tier3-items", getTier3Items);
gqlResolvers.set("tier3-events", getTier3Events);

export const gqlCallResolver = async <T, U>(
  p: GqlResolverPayload<T>
): Promise<{ data: { data: U } }> => {
  const resolver = gqlResolvers.get(p.type) as GqlCallResolverFn;
  const res: { data: { data: U } } = await resolver(p.payload);
  return res;
};
